import { Container } from '@mui/material';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function HomePage() {
  const location = useLocation();
  // const jumpToDigitizing = () => {
  //   setServicesAnchorEl(null);
  // };

  useEffect(() => {
    // Always scroll to top when HomePage loads
    try {
      if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') {
        window.scrollTo(0, 0);
      }
    } catch (e) {
      // Some test environments (jsdom) don't implement scrollTo; ignore.
    }
  }, [location]);

  return (
    <>
      <div style={{ position: 'relative', width: '100%', boxSizing: 'border-box', overflow: 'hidden', marginTop: '67px',
         backgroundImage: "url('/DO_Strat_Logo.jpg')", backgroundSize: 'max(950px, 63vw) auto', backgroundRepeat: 'no-repeat',
         backgroundColor: '#000000ff', minHeight: '60vh', backgroundPositionX: 'max(267px, 18vw)', backgroundPositionY: 'top',
        }}>
        <Container sx={{ py: 4 }}>
        </Container>
        {/* Fade effect at bottom */}
        <div style={{
          position: 'absolute', left: 'max(267px, 18vw)', width: 'max(950px, 63vw)', bottom: 0, height: 'clamp(60px, 7.5vw, 120px)',
           background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%, #000 100%)', pointerEvents: 'none',
        }} />
        {/* Fade effect at left — positioned relative to the centered background image (backgroundSize: 65%).
            This keeps the fade locked to the image as the viewport resizes. */}
                {/* Fade effect at left — positioned relative to the centered background image (backgroundSize: 65%).
            This keeps the fade locked to the image as the viewport resizes. */}
        <div style={{position: 'absolute', left: 'max(267px, 18vw)', width: 'max(115px, 7.8vw)', top: 0, bottom: 0,
          /* width expressed relative to the background-image width (65% of container) */
          background: 'linear-gradient(to right, #000 0%, rgba(0,0,0,0) 100%)', pointerEvents: 'none',
        }} />
        {/* Fade effect at right — symmetric to the left fade */}
        <div style={{
          position: 'absolute', right: 'calc(100% - max(267px, 18vw) - max(950px, 63vw))', width: 'max(115px, 7.8vw)', 
          top: 0, bottom: 0, background: 'linear-gradient(to left, #000 0%, rgba(0,0,0,0) 100%)', pointerEvents: 'none',
        }} />
      </div>
      {/* Welcome text section */}
      {/* padding always at least 24px between window edges; divide extra width evenly between left and right
      when window exceeds 1400 px; keep inner 1400px centered on large screens */}
      <div style={{ width: '100%', background: '#000', boxSizing: 'border-box', padding: '48px max(85px, calc((100vw - 1400px) / 2)) 100px' }}>
        <div style={{ color: '#fff', textAlign: 'center', fontFamily: 'Inter, sans-serif', fontSize: '2rem', fontWeight: 500, minWidth: '1300px',}}>
          <h2 style={{ margin: 0, fontSize: '3.5rem', fontWeight: 525 }}>
            Welcome to the Next Era of Subsurface Analysis
            </h2>
        </div>
      </div>
      {/* Full-width black section with image left, text right */}
      <div
       style={{ width: '100%', background: '#000', boxSizing: 'border-box', padding: '0 max(90px, calc((100vw - 1300px) / 2)) 50px'}}>
        {/*padding: '0=top max(24px, calc((100vw - 1450px) / 2)) = left-right responsize 50px = bottom'  */}
        <div
         style={{width: '100%', maxWidth: '1300px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'flex-start',
          flexWrap: 'nowrap', gap: 'clamp(100px, 5vw, 100px)', minHeight: '400px' }}>
          {/* style={{width: '100%', background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', minHeight: '400px', */}
          {/* boxSizing: 'border-box', gap: '100px', padding:'0px 50px 50px 90px'}}> */}
          {/*clamp (20px, 5vw, 90px) means: use 20px if the viewport is smaller than 400px, use 5vw if the viewport is between 400px and 1800px, and use 90px if the viewport is larger than 1800px */}
          {/* padding: top right bottom left */}
          {/* flex: '0 0 800px' a setting like this will force the container to be 800 (or whatever) px wide*/}
          <div 
           style={{flex: '1 1 600px', color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '2rem', fontWeight: 500,
            maxWidth: '700px', minWidth: '575px' }}>
              <p style={{ marginTop: '2px', fontSize: '1.95rem', textAlign: 'left', lineHeight: 1.5 }}>
                Ad Valorem Taxes Made Easy
              </p>
              <p
              style={{marginTop: '24px', fontSize: '1.125rem', fontFamily: 'Inter, sans-serif', lineHeight: 1.5, textAlign: 'left' }}>
                The world of taxes can be extremely complex and time consuming.  However, our team of experts thought there
                was a better way.  We have developed a web platform that simplifies the process and puts the power of
                viewing, tracking, and managing Ad Valorem taxes in the hands of the taxpayer.  This is a tool for operators
                and interest owners, with no industry experience, alike.  There's no longer a need to hire expensive consultants
                or spend countless hours trying to reverse engineer tax appraisals.
              </p>
              <div style={{ marginTop: '24px', display: 'flex', justifyContent: 'center', width: '100%' }}>
                  <button
                    style={{
                      background: '#ffffff', color: '#000', border: 'none', borderRadius: '8px',
                      padding: '12px 24px', fontSize: '1rem', fontWeight: 700, cursor: 'pointer',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.25)'
                    }}
                    onMouseDown={e => e.currentTarget.style.background = '#8d8c8cff'}
                    onMouseUp={e => e.currentTarget.style.background = '#ffffffff'}
                    onMouseLeave={e => e.currentTarget.style.background = '#ffffffff'}
                    onClick={() => window.location.href = '/Adval_Taxes'}
                  >
                    Start Enjoying Straightforward Ad Valorem Taxes
                  </button>
                </div>
            </div>
          <div
            style={{maxWidth: '850px', minWidth: '640px', minHeight: '360px' }}>
                <img src="/Pump_jack_over_ledger.jpeg" alt="Section"
                style={{display: 'block', height: '100%', width: '100%', objectFit: 'cover', borderRadius: '16px',
                 boxShadow: '0 4px 16px rgba(0,0,0,0.5)' }} />
          </div>
        </div>
      </div>  
      {/* //log image and "unmatched speed" section */}
      <div 
       style={{ position: 'relative', width: '100%', background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'flex-start',
        minHeight: '400px', boxSizing: 'border-box', gap: 'clamp(125px, 5vw, 100px)', padding: '80px max(90px, calc((100vw - 1300px) / 2)) 0' }}>
          <div style={{minWidth: '550px', maxWidth: '550px', minHeight: '450px', maxHeight: '450px', overflow: 'hidden',
             borderRadius: '16px', boxShadow: '0 4px 16px rgba(0,0,0,0.5)' }}>
            <img src="/Cropped_Log.png" alt="Section" style={{ display: 'block', width: '100%', height: '25%', objectFit: 'cover' }}/>
          </div>
          <div style={{ flex: 1, color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '2rem', fontWeight: 500,
             maxWidth: '700px', minWidth: '700px' }}>
            <p style={{ marginTop: '24px', fontSize: '1.95rem', lineHeight: 1.5, textAlign: 'left'  }}>
              Unmatched Digitizing Speed and Affordability
            </p>
            <p style={{ marginTop: '24px', fontSize: '1.125rem', fontFamily: 'Inter, sans-serif', lineHeight: 1.5, textAlign: 'left', maxWidth:'650px'}}>
              Digitizing well logs has long been a time consuming and costly endeavor.  
              Our proprietary, AI driven log digitization technology allows us to deliver high quality LAS files
              at a fraction of the cost and time of traditional methods.  We can digitize an entire TCOM detail section, run in fresh mud,
              in under 30 minutes for just $40 USD, assuming each curve is 1000 ft for example purposes.
            </p>
            <div style={{ marginTop: '24px', display: 'flex', justifyContent: 'flex-start' }}>
              <button style={{
                  background: '#ffffff', color: '#000', border: 'none', borderRadius: '8px',
                  padding: '12px 24px', fontSize: '1rem', fontWeight: 700, cursor: 'pointer',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.25)' }}
                onMouseDown={e => e.currentTarget.style.background = '#8d8c8cff'}
                onMouseUp={e => e.currentTarget.style.background = '#ffffffff'}
                onMouseLeave={e => e.currentTarget.style.background = '#ffffffff'}
                onClick={() => window.location.href = '/digitization'}
              >
                Price Your Own Project
              </button>
            </div>
          </div>
        </div>
      <div
       style={{ width: '100%', background: '#000', boxSizing: 'border-box', padding: '150px max(90px, calc((100vw - 1300px) / 2)) 50px' }}>
        <div
         style={{width: '100%', maxWidth: '1300px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'flex-start',
          flexWrap: 'nowrap', gap: 'clamp(100px, 5vw, 100px)', minHeight: '400px' }}>
            <div 
           style={{flex: '1 1 600px', color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '2rem', fontWeight: 500,
            maxWidth: '700px', minWidth: '575px' }}>
              <p style={{ marginTop: '2px', fontSize: '1.95rem', textAlign: 'left', lineHeight: 1.5}}>
                Streamlined Data Pipelines
              </p>
              <p
              style={{marginTop: '24px', fontSize: '1.125rem', fontFamily: 'Inter, sans-serif', lineHeight: 1.5, textAlign: 'left' }}>
                Rservoir management and analysis is a puzzle compposed of many pieces.  This is why we have integrated our revolutionary
                 technology into a suite of data management and analysis tools that is constantly growing.  Seamlessly transfer your 
                 digitized logs, financial analysis, and other data into our platform for enhanced insights and decision-making.
              </p>
            </div>          
            <div
            style={{maxWidth: '650px', minWidth: '650px' }}>
                <img src="/GEO_DB_MANAGMENT.png" alt="Section"
                style={{displya: 'block', width: '100%', height: '450px', objectFit: 'cover',
                      borderRadius: '16px', boxShadow: '0 4px 16px rgba(0,0,0,0.5)' }} />
            </div>
        </div>
      </div>
      {/* <div
        style={{ width: '100%', background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', 
          minHeight: '400px', padding: '48px 0' }}>
            <div
              style={{flex: '0 0 350px', display: 'flex', justifyContent: 'flex-end', 
                alignItems: 'center', height: '100%', paddingLeft: '90px' }}>
                  <img src="/Geoscience_AI.png" alt="Section"
                  style={{width: '550px', height: '500px', objectFit: 'cover', borderRadius: '16px', 
                    boxShadow: '0 4px 16px rgba(0,0,0,0.5)', transform: 'translateX(10px)' }} />
            </div>
            <div
              style={{width: '100%', background: '#000', display: 'flex', alignItems: 'center', 
                justifyContent: 'center', minHeight: '400px', padding: '48px 0' }}>        
                <div
                  style={{flex: 1, color: '#fff', paddingLeft: '80px', fontFamily: 'Inter, sans-serif', 
                    textAlign: 'left', transform: 'translateY(-30px)' }}>
                    <p style={{ marginTop: '24px', fontSize: '1.95rem', lineHeight: 1.5 }}>
                      LAS & TIF Database
                    </p>
                    <p
                      style={{ marginTop: '24px', fontSize: '1.125rem', fontFamily: 'Inter, sans-serif', 
                      lineHeight: 1.5, textAlign: 'left', maxWidth:'650px' }}>
                        We are constantly expanding our LAS & TIF Database. Be sure to check our existing database regularly in case
                        we already have the log data you are looking for.
                    </p>
                </div>
            </div>
      </div>     */}
    </>
  );
}
